export default __webpack_public_path__ + "static/media/img_about-photos-m05.6293ba8d.jpg";